export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const UPDATE_FORGOT_PASSWORD_FIELD = 'UPDATE_FORGOT_PASSWORD_FIELD'
export const FORGOT_PASSWORD_SUCCESS_HEADING = 'Check Your Email'
export const FORGOT_PASSWORD_SUCCESS_CONTENT = 'A password reset link has been sent.'



// WEBPACK FOOTER //
// ./src/pages/forgot-password/constants.ts